//export const whitelabel_id = "c24f7b7f-b91c3a84-8edeeb5a-a8f6306c-2df29dc6-8ff85c3c-63a35393-b6a08945"
//export const recaptchaSiteKey = "6LfeZGMpAAAAAGr0a3cLVXQPV0TTcAEXwXnwCDCl"
//export const recaptchaSecretKey = "6LfeZGMpAAAAAO1u4TJ89KwnwTDoxJIP9wWoapbT"
export const whitelabel_id = "9b7a9e52-5b13eb6e-107a5683-1a4c73a8-d0238ee7-bb0a6746-33a08089-a6b0f363"
export const recaptchaSiteKey = "6LdBOmkpAAAAAMmLiSje3s6OT7NPOdP6oQ-vmLeK"
